/* src/components/Footer.js */
import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="site-name">DEF CON Glossary</div>
      <div className="social-links">
        <a href="https://twitter.com/DefconParrot" target="_blank" rel="noopener noreferrer">
          Twitter 
        </a>
        <a href="https://linktr.ee/defconparrot" target="_blank" rel="noopener noreferrer">
          Link-of-Links
        </a>
        <a href="https://www.instagram.com/DefconParrot" target="_blank" rel="noopener noreferrer">
          Instagram
        </a>
      </div>
    </footer>
  );
};

export default Footer;
